import { IconButton, OutlinedInput } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { ChangeEvent, useCallback, useState } from "react";
import { useMessages } from "src/context/MessagingProvider";
import { useTranslation } from "react-i18next";

const NewMessageForm = () => {
  const [newMessage, setNewMessage] = useState("");
  const { sendMessage } = useMessages();
  const page = "messaging";
  const { t } = useTranslation();

  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setNewMessage(event.target.value);
  }, []);

  const handleSend = useCallback(async () => {
    sendMessage(newMessage);
    setNewMessage("");
  }, [newMessage, sendMessage]);

  return (
    <OutlinedInput
      slotProps={{
        root: {
          style: {
            marginTop: "auto",
          },
        },
      }}
      value={newMessage}
      onChange={handleChange}
      id="outlined-adornment"
      type="text"
      multiline
      maxRows={10}
      placeholder={t(`${page}.inputPlaceholder`)}
      sx={{
        background: "#F8F8F8",
        borderRadius: "10px",
        width: "100%",
        color: "#000",
        gap: "1rem",
        padding: "10px 15px",
        mt: "auto",
      }}
      endAdornment={
        <IconButton
          sx={{ color: "#00B6B9" }}
          onClick={handleSend}
          disabled={newMessage.length === 0}
        >
          <SendIcon />
        </IconButton>
      }
    />
  );
};

export default NewMessageForm;
